import React, { Component } from 'react'
import Panel from '../Panel'

/**
 * 完成服务卡片
 */
class FinishCard extends Component {
  render() {
    const { item, operator } = this.props
    const { finish_card } = item
    return (
      <Panel
        icon="//qnm.hunliji.com/o_1d8n9130lso01jml12nu1ctccd17.png"
        item={item}
      >
        <div className="item">
          <span>备注&nbsp;:&nbsp;</span>
          <span>{finish_card.remark}</span>
        </div>

        <div className="item">
          <span>操作人&nbsp;:&nbsp;</span>
          <span>{operator}</span>
        </div>
        {/*<div className="item">
          <span>任务执行状态&nbsp;:&nbsp;</span>
          <span>{finish_card.result}</span>
        </div>*/}
        {/*<a onClick={() => this.props.scrollToAnchor('659')}>跳转任务创建记录</a>*/}
      </Panel>
    )
  }
}

export default FinishCard
